import React from "react";

function ContactMe() {
  return (
    <section className="section-contact" id="contact">
      <h4 className="section-contact__heading">
        Have Any Project In Mind?{" "}
        <span className="section-contact__heading--main">Say Hello At</span>{" "}
      </h4>
      <h3 className="section-contact__subheading">rk220217@gmail.com</h3>
    </section>
  );
}

export default ContactMe;
